import axios from "axios";
import store from "../stores/store";
import { apiConfig } from "@/_helpers/apiHelper";
import msal from "@/msal";

let axiosConnection = axios.create();

axiosConnection.interceptors.request.use(async (config) => {
  config.baseURL = `${store.state.configuration.SO_API_BASE_URL}/api`;

  if (store.getters["configuration/ssoAvailable"]) {
    // Check if the user is a microsoft auth user or a normal login
    const msAuth = store.getters["users/isSSO"];

    if (msAuth) {
      let res = undefined;
      try {
        res = await msal.getToken();
      } catch (e) {
        console.error("MSAL error", e);
      }

      if (res !== undefined)
        store.commit("users/SET_TOKEN", res, {
          root: true,
        });

      return {
        ...config,
        ...apiConfig(),
      };
    }
  }

  // Set the token from either the store or the SSO
  config = {
    ...config,
    ...apiConfig(),
  };

  return config;
});

export default axiosConnection;
